// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_58-6";
export var headerCell = "_58-2";
export var rowWrapper = "_58-4";
export var stickyAggregationCell = "_58-a";
export var stickyAggregationRow = "_58-7";
export var stickyColumnCell = "_58-9";
export var stickyColumnHeaderCell = "_58-8";
export var table = "_58-1";
export var virtualRowWrapper = "_58-5";
export var virtualTableContainer = "_58-0";
export var white = "_58-3";